export default __webpack_public_path__ + "static/media/windows_logo.3e6103e4.png";